import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/users/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')


const UsersList = () => import('@/views/users/UsersList')
const UsersDetails = () => import('@/views/users/UsersDetails')
const Profile = () => import('@/views/users/Profile')
const ForgotPassword = () => import('@/views/users/ForgotPassword')
const ResetPassword = () => import('@/views/users/ResetPassword')

const AdvertsLists = () => import('@/views/adverts/AdvertsLists')
const AdvertsDetails = () => import('@/views/adverts/AdvertsDetails')

const CreditSettings = () => import('@/views/credits/CreditSettings')
const CreditsLists = () => import('@/views/credits/CreditsLists')
const FreeCreditSettings = () => import('@/views/credits/FreeCreditSettings')

const ReasonList = () => import('@/views/reason/ReasonList')
const AddReason = () => import('@/views/reason/AddReason')
const EditReason = () => import('@/views/reason/EditReason')

const ListReport = () => import('@/views/report/ListReport')
Vue.use(Router)

export default new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      beforeEnter: (to, from, next) => {
        isLoggedIn(to,from,next);
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: 'users-list',
          meta: {
            label: 'User List'
          },
          name: 'UsersList',
          component: UsersList,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'adverts-list',
          meta: {
            label: 'Advert List'
          },
          name: 'AdvertsLists',
          component: AdvertsLists,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'advert-details/:id',
          meta: {
            label: 'Advert Detail'
          },
          name: 'AdvertsDetails',
          component: AdvertsDetails,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'credits-list',
          meta: {
            label: 'Credit List'
          },
          name: 'CreditsLists',
          component: CreditsLists,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'users-details/:id',
          meta: {
            label: 'User Detail'
          },
          name: 'UsersDetails',
          component: UsersDetails,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'profile',
          meta: {
            label: 'Profile'
          },
          name: 'profile',
          component: Profile,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'credit-settings',
          meta: {
            label: 'Credit Setting'
          },
          name: 'credit settings',
          component: CreditSettings,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'free-credit-settings',
          meta: {
            label: 'Free Credit Setting'
          },
          name: 'free credit settings',
          component: FreeCreditSettings,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'reason-list',
          meta: {
            label: 'Reason List'
          },
          name: 'reason list',
          component: ReasonList,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [

          ]
        },
        {
          path: 'reason-list/add',
          meta: {
            label: 'Add Reason'
          },
          name: 'add reason',
          component: AddReason,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'reason-list/edit/:id',
          meta: {
            label: 'Edit Reason'
          },
          name: 'edit reason',
          component: EditReason,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        },
        {
          path: 'report-list',
          meta: {
            label: 'Report List'
          },
          name: 'report list',
          component: ListReport,
          beforeEnter: (to, from, next) => {
            isLoggedIn(to,from,next);
          },
          children: [
          ]
        }
      ]
    },
    {
      path: '*',
      name: 'Page404',
      component: Page404,
      children: [
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      children: [
      ]
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      children: [

      ]
    },
    {
      path: '/reset-password/:id',
      name: 'Reset password',
      component: ResetPassword,
      children: [

      ]
    }
  ]
}
export const isLoggedIn = function(to, from, next) {
  if(from.name != "AdvertsDetails" && to.name == "AdvertsLists") {
    localStorage.removeItem('advertfromdate');
    localStorage.removeItem('adverttodate');
  }
  if(localStorage.getItem('userdata') != null)// && localStorage.getItem('token') != null
  {
      if(to.matched.some(record => record.name  == 'Login')) {
        next({name: 'Dashboard'});
      } else {
        next();
      }
      next();
  } else {
      next({name: 'Login'});
  }
};
